import './App.css';
import Layout from "./pages/Layout";
import { Provider } from 'react-redux'
import store from './store.js'

function App_layout() {
  

  
  return (
    <>
      <Provider store={store}> 
            <Layout />
            
      </Provider>
    </>
  );
}

export default App_layout;
